import { TZDate } from '@toast-ui/calendar';
import React, { ReactElement } from 'react';
import ICalendarFactory from './ICalendarFactory.tsx';

class role {
  id: string;

  constructor(id: string) {
    this.id = id;
  }
}

class user {
  id: string | undefined;
  firstname: string;
  lastname: string;
  abl: string[];
  role: { id_role: string, iluo: number }[];

  constructor(firstname: string, lastname: string, id?: string) {
    this.id = id ? '' : id;
    this.firstname = firstname;
    this.lastname = lastname;
    this.abl = [];
    this.role = [];
  }
}


class RoleTask {
  id: string;
  abl: string[];
  role: { id_role: string, iluo: number }[];
  user: user[]
  count: number;

  constructor(id: string, count: number, abl: string[] = [], role: { id_role: string, iluo: number }[] = [], user: user[] = []) {
    this.id = id;
    this.count = count;
    this.abl = abl;
    this.role = role;
    this.user = user;
  }
}

class task {
  id: string
  user: string[]
  roleTask: RoleTask[]
  hours: { start: string, end: string }
  actions: action[];
  date: string;

  constructor(id: string, hours: { start: string, end: string }, date: string) {
    this.id = id;
    this.user = [];
    this.roleTask = [];
    this.hours = hours
    this.actions = [];
    this.date = date;
  }
}


class action {
  id_actions: string;
  id_users: string;
  id_case_plannings: string;
  id_action_anomaly?: string;
  info?: string;
  dateStart: string;
  dateEnd: string;
  break: number;

  constructor(id_actions: string, id_users: string, id_case_plannings: string, id_action_anomaly: string | undefined, info: string | undefined, dateStart: string, dateEnd: string, breaks: number) {
    this.id_actions = id_actions;
    this.id_users = id_users;
    this.id_case_plannings = id_case_plannings;
    this.id_action_anomaly = id_action_anomaly;
    this.info = info;
    this.dateStart = dateStart;
    this.dateEnd = dateEnd;
    this.break = breaks;
  }
}



class planning {
  id: string
  monday: Date
  tasks: task[]

  constructor(id: string, monday: Date) {
    this.id = id;
    this.monday = monday;
    this.tasks = [];
  }
}

class FictivesData {
  type_actions: string[];
  abilities: string[];
  locations: string[];
  roles: role[];
  users: user[];
  plannings: planning[];

  constructor() {
    this.type_actions = [
      '1b3e73c7-31f0-4bc9-a2be-26092a2d20af',
      'fbb827c7-bade-41a2-87e9-bf7a32cb730b',
      '53c94d67-5f27-4247-aca3-f2b3a31838c9',
      '89cd6c12-1875-4f0e-8481-3bca3e736070'
    ];
    this.abilities = ['a1', 'a2', 'a3', 'a4', 'a5', 'a6', 'a7'];
    this.locations = [
      "1b3e73c7-31f0-4bc9-a2be-26092a2d20af",
      "b151c6b8-c414-4465-861a-5d05991f69ec",
      "1e0d6221-d258-4bf9-92cb-ebcbcf615fb5"
    ];
    this.users = [
      new user('Clara', 'Dupont'),
      new user('Julien', 'Martin'),
      new user('Sophie', 'Lefevre'),
      new user('Lucas', 'Moreau'),
      new user('Emma', 'Dubois'),
      new user('Antoine', 'Bernard'),
      new user('Léa', 'Simon'),
      new user('Thomas', 'Gérard'),
      //{ firstname: 'Camille', lastname: 'Roux', abl: [], role: [] },
      //{ firstname: 'Maxime', lastname: 'Pelletier', abl: [], role: [] },
    ];

    this.roles = [
      new role('r1'),
      new role('r2'),
      new role('r3'),
      new role('r4'),
      new role('r5'),
      new role('r6'),
      new role('r7'),
      new role('r8')
    ];
    this.plannings = [];
  }

  getAllTask(): task[] {
    const tasks: task[] = [];
    for (let planning of this.plannings) {
      for (let task of planning.tasks) {
        tasks.push(task);
      }
    }
    return tasks;
  }
}

class requestString {
  res: string[];

  constructor() {
    this.res = [];
  }

  line(str: string): void {
    if (str !== "") this.res.push(str);
  }
  semicolon(): void {
    this.res[this.res.length - 1] = this.res[this.res.length - 1].slice(0, -1) + ';';
  }
  separate(): void {
    this.res.push('-- -- --');
  }
  toString(): string {
    return this.res.join('\n');
  }
}




export class GenerateFictiveData {
  static getRandom(list: any[]) {
    return list[Math.floor(Math.random() * list.length)];
  }

  static getRandomHour() {
    const hours: { start: string, end: string } = { start: '', end: '' };

    let check = false;
    let hour = Math.floor(Math.random() * 7) + 9; //[9 - 15]

    let start_hour: number, end_hour: number, start_minute: number, end_minute: number, start_scrore: number, end_scrore: number;

    while (!check) {
      start_hour = hour - Math.floor(Math.random() * 3); //[9 - 15] - [0 - 2] => [7 - 15]
      end_hour = hour + Math.floor(Math.random() * 3); //[9 - 15] + [0 - 2] => [9 - 17]

      start_minute = (Math.floor(Math.random() * 4)) * 15; //[0 - 45]
      end_minute = (Math.floor(Math.random() * 4)) * 15; //[0 - 45]

      start_scrore = start_hour * 60 + start_minute;
      end_scrore = end_hour * 60 + end_minute;

      if (end_scrore - start_scrore >= 30) {
        check = true;
        hours.start = (start_hour < 10 ? '0' : '') + start_hour + ':' + (start_minute < 10 ? '0' : '') + start_minute;
        hours.end = (end_hour < 10 ? '0' : '') + end_hour + ':' + (end_minute < 10 ? '0' : '') + end_minute;
      }
    }
    return hours;
  }


  static getRandomDay = (monday: Date) => {
    const rand = Math.floor(Math.random() * 5);
    let val = (1000 * 60 * 60 * 24 * rand);
    const new_day = new Date(monday.getTime() + val);

    return ICalendarFactory.TZDateFormat(new TZDate(new_day));
  }

  static getRandomDate() {
    let day = (Math.floor(Math.random() * 30) + 1);
    let month = (Math.floor(Math.random() * 12) + 1);
    let year = (Math.floor(Math.random() * 30)) + 2024;

    return year + '-' +
      (month < 10 ? '0' : '') + month + '-' +
      (day < 10 ? '0' : '') + day;
  }


  /* ------------------------------------------------- */

  generateTask(nb: number, offset_task: number, planning: planning) {
    const today = ICalendarFactory.TZDateFormat(new TZDate())
    if (nb <= 0) return;

    this.res.line('-- --');
    this.res.line("INSERT INTO `case_plannings`(`id_case_plannings`, `id_plannings`, `status`, `date`, `id_transport`, `date_id_transport`, `debord`, `nbSmallPackage`, `nbBigPackage`, `hourly_start`, `hourly_end`, `id_location`, `id_type_action`) VALUES");

    for (let index = offset_task; index < (nb + offset_task); index++) {
      let id = 't' + index + planning.id;
      let location = GenerateFictiveData.getRandom(this.data.locations);
      let type_action = GenerateFictiveData.getRandom(this.data.type_actions);
      let hours = GenerateFictiveData.getRandomHour();
      let date = GenerateFictiveData.getRandomDay(planning.monday);

      let statu = (date < today ?
        ((Math.floor(Math.random() * 12) === 0) ? 'LATE' : 'DONE')
        : 'COMING'
      );

      this.res.line(
        '(\'' + id + '\', ' +
        '\'' + planning.id + '\', ' +
        '\'' + statu + '\', ' +
        '\'' + date + '\', ' +
        '\'NULL\', ' +
        '\'NULL\', ' +
        '\'0\', ' +
        '\'0\', ' +
        '\'0\', ' +
        '\'' + hours.start + '\', ' +
        '\'' + hours.end + '\', ' +
        '\'' + location + '\', ' +
        '\'' + type_action + '\'),'
      );
      planning.tasks.push(new task(id, hours, date));
    }
    this.res.semicolon();
  }



  generateTaskAction(planning: planning) {
    this.res.line('-- --');
    this.res.line("INSERT INTO `actions`(`id_actions`, `id_users`, `id_case_plannings`, `id_action_anomaly`, `info`, `dateStart`, `dateEnd`, `tps_break`) VALUES");

    const today = ICalendarFactory.TZDateFormat(new TZDate())

    console.log(planning)
    planning.tasks.forEach((task, it) =>
      task.roleTask.forEach((roleTask, irt) => {
        let tpm_res = '';
        for (let count = 0; count < roleTask.count; count++) {

          let dateEnd = '00:00';
          let dateStart = '00:00';
          let breaks = 0;

          if (task.date < today) {
            dateEnd = task.hours.end;
            if (Math.floor(Math.random() * 3) === 0) {
              let new_end = ICalendarFactory.HourToDecimal(dateEnd) + (Math.floor(Math.random() * 40 - 20) / 10);
              dateEnd = ICalendarFactory.decimalToHour(new_end);
            }

            dateStart = task.hours.start;
            if (Math.floor(Math.random() * 3) === 0) {
              let new_start = ICalendarFactory.HourToDecimal(dateStart) + (Math.floor(Math.random() * 40 - 20) / 10);
              dateStart = ICalendarFactory.decimalToHour(new_start);
            }

            if (Math.floor(Math.random() * 3) === 0)
              breaks = Math.floor(Math.random() * 1200000 + 30000) // between 20min30 and 30s
          }

          let a = new action(
            ('action_' + planning.id + '_' + it + '_' + irt + count),
            '00f0b4cb-dc3c-4262-8a69-4f8f266af3fe',
            task.id,
            undefined,
            undefined,
            dateStart,
            dateEnd,
            breaks
          );

          tpm_res +=
            '(\'' + a.id_actions + '\', ' +
            '\'' + a.id_users + '\', ' +
            '\'' + a.id_case_plannings + '\', ' +
            '\'NULL\', ' +
            '\'NULL\', ' +
            '\'' + a.dateStart + '\', ' +
            '\'' + a.dateEnd + '\', ' +
            '\'' + a.break + '\'),'
            ;

          task.actions.push(a)
        }
        this.res.line(tpm_res)
      })

    )

    this.res.semicolon();
  }



  generateUser(nb: number, offset_user: number): void {
    if (nb <= 0) return;

    this.res.line('-- --');
    this.res.line("INSERT INTO `users` (`id`, `email`, `firstname`, `lastname`, `language`, `register_date`, `last_activity`) VALUES");

    for (let index = offset_user; index < (nb + offset_user); index++) {
      let id = 'u' + index;
      let user = this.data.users[index - offset_user];
      let email = user.firstname.toLocaleLowerCase() + '.' + user.lastname.toLocaleLowerCase() + '@prod-eo.com';

      this.res.line(
        '(\'' + id + '\', ' +
        '\'' + email + '\', ' +
        '\'' + user.firstname + '\', ' +
        '\'' + user.lastname + '\', ' +
        '\'fr\', ' +
        '\'2024-04-26T00:00:00.000Z\', ' +
        '\'2024-01-08T15:20:47.261Z\'),'
      );
      user.id = id;
    }
    this.res.semicolon();


    this.res.separate();
    this.res.line("INSERT INTO `users_abilities` (`id_user`, `id_ability`, `date_end`) VALUES");

    for (let index = offset_user; index < (nb + offset_user); index++) {
      let user = this.data.users[index - offset_user];
      let a: string[] = [];
      let tpm_res = '';

      let rand = Math.floor(Math.random() * 4) + 1;
      for (let i = 0; i <= rand; i++) {
        let ability = GenerateFictiveData.getRandom(this.data.abilities);
        if (!a.includes(ability)) {
          a.push(ability);
          tpm_res +=
            '(\'' + user.id + '\', ' +
            '\'' + ability + '\', ' +
            '\'' + GenerateFictiveData.getRandomDate() + '\'),'
            ;
          user.abl.push(ability);
        }
        else i--;
      }
      this.res.line(tpm_res);
    }
    this.res.semicolon();


    this.res.separate();
    this.res.line("INSERT INTO `users_roles` (`id_user`, `id_role`, `value`) VALUES");

    for (let index = offset_user; index < (nb + offset_user); index++) {
      let user = this.data.users[index - offset_user];
      let a: string[] = [];
      let tpm_res = '';

      let rand = Math.floor(Math.random() * 4) + 1;
      for (let i = 0; i <= rand; i++) {
        let role = GenerateFictiveData.getRandom(this.data.roles)
        if (!a.includes(role)) {
          let iluo = (Math.floor(Math.random() * 4) + 1);

          a.push(role);
          tpm_res +=
            '(\'' + user.id + '\', ' +
            '\'' + role.id + '\', ' +
            '\'' + iluo + '\'),'
            ;
          user.role.push({ id_role: role.id, iluo: iluo });
        }
        else i--;
      }
      this.res.line(tpm_res);
    }
    this.res.semicolon();


    this.res.separate();
    this.res.line("INSERT INTO `users_auth` (`users_id`, `password`, `account_lock`, `code_key`, `code_date`, `code_attempts`) VALUES");
    for (let index = offset_user; index < (nb + offset_user); index++) {
      this.res.line('(\'' + ('u' + index) + '\', \' psswd \', 0, \'NULL\', \'NULL\', 0),');
    }
    this.res.semicolon();


    this.res.separate();
    this.res.line("INSERT INTO `users_groups`(`id_users`, `id_groups`) VALUES");
    for (let index = offset_user; index < (nb + offset_user); index++) {
      this.res.line('(\'' + ('u' + index) + '\', \'57429740-e360-4156-8521-6b675c355063\'),');
    }
    this.res.semicolon();
  }


  role_tasks(nb: number, planning: planning) {
    if (nb <= 0) return;

    this.res.line('-- --');
    this.res.line("INSERT INTO `roles_tasks`(`id_roles_tasks`, `id_task`, `count`) VALUES");
    let index = 0;
    for (let task of planning.tasks) {
      let tpm_res = '';
      let nb_role = (Math.floor(Math.random() * 4));

      for (let i = 0; i < nb_role; i++) {
        const nb_user = (Math.floor(Math.random() * 2) + 1);
        let id = 'rt' + '_' + task.id + '_' + index;

        tpm_res +=
          '(\'' + id + '\', ' +
          '\'' + task.id + '\', ' +
          '\'' + nb_user + '\'),';

        task.roleTask.push(new RoleTask(id, nb_user));
        index++;
      }
      this.res.line(tpm_res);
    }
    this.res.semicolon();


    this.res.line('-- --');
    this.res.line("INSERT INTO `roles_tasks_skills`(`id_roles_tasks`, `id_skill`, `iluo`) VALUES");
    index = 0;
    for (let task of planning.tasks) {
      let index_rt = 0;
      let tpm_res = '';
      for (let role_task of task.roleTask) {
        const buff: role[] = [];
        let nb_role = (Math.floor(Math.random() * 2) + 1);

        for (let i = 0; i < nb_role; i++) {
          let role: role = GenerateFictiveData.getRandom(this.data.roles);
          if (!buff.includes(role)) {
            buff.push(role);
            const iluo = (Math.floor(Math.random() * 4) + 1);
            tpm_res +=
              '(\'' + role_task.id + '\', ' +
              '\'' + role.id + '\', ' +
              '\'' + iluo + '\'),';

            role_task.role.push({ id_role: role.id, iluo: iluo });
          } else i--;
        }
      }
      this.res.line(tpm_res);
      index++;
    }
    this.res.semicolon();


    this.res.line('-- --');
    this.res.line("INSERT INTO `roles_tasks_abilities`(`id_roles_tasks`, `id_ability`) VALUES");
    index = 0;
    for (let task of planning.tasks) {
      let index_rt = 0;
      let tpm_res = '';
      for (let role_task of task.roleTask) {
        const buff: string[] = [];
        let nb_abl = (Math.floor(Math.random() * 3));

        for (let i = 0; i < nb_abl; i++) {
          let ability: string = GenerateFictiveData.getRandom(this.data.abilities);
          if (!buff.includes(ability)) {
            buff.push(ability);
            tpm_res +=
              '(\'' + role_task.id + '\', ' +
              '\'' + ability + '\'),';

            role_task.abl.push(ability);
          } else i--;
        }
      }
      this.res.line(tpm_res);
      index++;
    }
    this.res.semicolon();



    this.res.line('-- --');
    this.res.line("INSERT INTO `roles_tasks_users`(`id_roles_tasks`, `id_user`) VALUES");
    index = 0;
    for (let task of planning.tasks) {
      const buff: user[] = [];

      let tpm_res = '';
      for (let role_task of task.roleTask) {
        let errors = 0;
        for (let i = 0; i < role_task.count; i++) {
          let user: user = GenerateFictiveData.getRandom(this.data.users);
          if (
            !buff.includes(user) && (
              (role_task.abl.length <= 0 || role_task.abl.every(a => user.abl.some(a2 => a2 === a))) &&
              (role_task.role.length <= 0 || role_task.role.every(r => user.role.some(
                r2 => (r2.id_role === r.id_role && r2.iluo >= r.iluo)
              )))
            )
          ) {
            buff.push(user);
            tpm_res +=
              '(\'' + role_task.id + '\', ' +
              '\'' + user.id + '\'),';

            role_task.user.push(user);
          }
          else {
            if (errors < 3) {
              errors++;
              i--;
            }
          }
        }
        errors = 0;
      }
      this.res.line(tpm_res);
      index++;
    }
    this.res.semicolon();
  }

  generatePlannings(nb: number, first_monday: Date) {
    const start_calendar = -5;

    if (nb <= 0) return;

    this.res.separate();
    this.res.line("INSERT INTO `plannings`(`id_plannings`, `name`) VALUES");

    for (let index = start_calendar; index < (nb + 0 + start_calendar); index++) {
      let monday = new Date(first_monday.getTime() + (1000 * 60 * 60 * 24 * 7 * index))
      let id = monday.getFullYear() + '_' + ICalendarFactory.getWeek(monday);

      this.res.line('(\'' + id + '\', \'' + id + '\'),');

      this.data.plannings.push(new planning(id, monday));
    }
    this.res.semicolon();
  }

  printTablePlanning(planning: planning) {
    this.res.separate();
    for (let task of planning.tasks) {
      this.res.line('----------------------------------')
      this.res.line('task ' + task.id)

      let abl = true;
      let role = true;
      let user = true;
      let count = false;


      this.res.line('| role_task : ')
      task.roleTask.map(rt => {
        this.res.line('. | role_task ' + rt.id + ' : ')
        user && this.res.line('. . | users : ')
        user && rt.user.map(u => (
          this.res.line('. . . - ' + u.id + ' -> ' + u.abl.join(', ') + ' | ' + u.role.map(r => (r.id_role + ' : ' + r.iluo)).join(', '))
        ))
        count && this.res.line('. . | count ' + rt.count)

        role && this.res.line('. . | roles : ')
        role && rt.role.map(r =>
          this.res.line('. . . - ' + r.id_role + '; iluo : ' + r.iluo)
        )

        abl && this.res.line('. . | abilities : ')
        abl && rt.abl.map(a =>
          this.res.line('. . . - ' + a)
        )
      })
      this.res.line('----------------------------------')
    }
  }

  printUserTable(users: user[], abilities: string[], roles: role[]) {
    this.res.separate();
    let tpm_line = '';

    const c = (str) => {
      str = ' ' + str;
      while (str.length < 3) str += '.';
      return '|' + str + ' |';
    }

    tpm_line = c('');
    for (let user of users) {
      tpm_line += c(user.id);
    }
    this.res.line(tpm_line)

    for (let abl of abilities) {
      tpm_line = c(abl);
      for (let user of users) {
        let ability = user.abl.find(a => a === abl);
        tpm_line += (c(ability ? ability : ''));
      }
      this.res.line(tpm_line)
    }
    this.res.separate();

    tpm_line = c('');
    for (let user of users) {
      tpm_line += c(user.id);
    }
    this.res.line(tpm_line)

    for (let role of roles) {
      tpm_line = c(role.id);
      for (let user of users) {
        let r1 = user.role.find(r => r.id_role === role.id);
        tpm_line += (c(r1 ? r1.iluo : ''));
      }
      this.res.line(tpm_line)
    }
  }

  res: requestString;
  data: FictivesData;
  randomListLink: { role_id: string, count: number }[][][];

  constructor() {
    this.res = new requestString();
    this.data = new FictivesData();
    this.randomListLink = [];
  }

  public static generate(nb_week: number, nb_task_per_week: number, nb_user: number, offset_task: number = 0, offset_user: number = 0) {
    const today = new Date();
    const monday = ICalendarFactory.getMonday(today);

    const generator = new GenerateFictiveData();

    generator.generatePlannings(nb_week, monday);
    generator.generateUser(nb_user, offset_user);

    for (let planning of generator.data.plannings) {
      generator.generateTask(nb_task_per_week, offset_task, planning);
      generator.role_tasks(nb_task_per_week, planning);
      generator.generateTaskAction(planning);
    }

    // to see bdd
    //generator.printTablePlanning(generator.data.plannings[0]);
    //generator.printUserTable(generator.data.users, generator.data.abilities, generator.data.roles);

    return generator.res.res;
  }

  toString() {
    return this.res.toString();
  }
}


